<template>
  <div class="base-text-copy">
    <el-tooltip content="点击复制">
      <div class="text" @click="copyText">
        <slot>{{ text }}</slot>
      </div>
    </el-tooltip>
  </div>
</template>

<script>
import utils from '@/libs/utils';

export default {
  components: {},
  props: {
    text: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {
    copyText() {
      utils.copyText(this.text);
      this.$message.success('复制成功');
    },
  },
};
</script>

<style lang="less" scoped>
.base-text-copy {
  .text {
    cursor: pointer;
    &:hover{
      color: #599FFF;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/base-text-copy.vue